import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
registerLocaleData(localeAr);
import { CommonModule } from '@angular/common';

// Helpers
import { MaterialModule } from '../helpers/material-modules';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from '../helpers/CustomPaginatorConfiguration';
import { DirtyCheckGuard } from '../helpers/CanDeactivate/dirty-check.guard';


import { RouterModule } from '@angular/router';
import { ShortNamePipe } from '../helpers/short-name.pipe';

import { SanitizeHtmlPipePipe } from '../helpers/sanitize-html-pipe.pipe';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { TimeAgoPipe } from '../helpers/time-ago.pipe';
import { DndDirective } from '../helpers/dnd.directive';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';
import { FilesViewerComponent } from './components/files-viewer/files-viewer.component';

import { SidenavOverComponent } from './components/sidenav-over/sidenav-over.component';
import { ConfirmAccessComponent } from './components/confirm-access/confirm-access.component';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { AdministrationPanelTabsComponent } from './components/administration-panel-tabs/administration-panel-tabs.component';
import { LogDetailsComponent } from './components/log-details/log-details.component';
import { SelectWithSearchComponent } from './components/select-with-search/select-with-search.component';
import { TreeFieldComponent } from './components/tree-field/tree-field.component';
import { TreeSelectionComponent } from './components/tree-selection/tree-selection.component';
import { TreeFieldRadioComponent } from './components/tree-field-radio/tree-field-radio.component';
import { TreeRadioComponent } from './components/tree-radio/tree-radio.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PrettyJsonPipe } from '../helpers/pretty-json.pipe';
import { CapitalizeMonthPipe } from '../helpers/capitalizeMonth.pipe';
import { InternalRoutePipe } from '../helpers/internalRoute.pipe';
import { SafeImgPipe } from '../helpers/safeImg.pipe';
import { SafePipe } from '../helpers/safe.pipe';
import { SanitizeTextPipe } from '../helpers/SanitizeText.pipe';
import { MaxNumberDirective } from '../helpers/max-number.directive';
import { AutoFocusOnEventDirective } from '../helpers/auto-focus.directive';

const components = [
  NoDataFoundComponent,
  FilesViewerComponent,
  SidenavOverComponent,
  ConfirmAccessComponent,
  FileManagerComponent,
  DynamicFormComponent,
  AdministrationPanelTabsComponent,
  LogDetailsComponent,
  SelectWithSearchComponent,
  TreeFieldComponent,
  TreeSelectionComponent,
  TreeFieldRadioComponent,
  TreeRadioComponent
]
const directives = [
  OnlynumberDirective,
  DropDownDirective,
  DndDirective,
  InfiniteScrollDirective,
  MaxNumberDirective,
  AutoFocusOnEventDirective
];
const pipes = [
  ShortNamePipe,
  TimeAgoPipe,
  SanitizeHtmlPipePipe,
  PrettyJsonPipe,
  CapitalizeMonthPipe,
  SanitizeTextPipe,
  InternalRoutePipe,
  SafeImgPipe,
  SafePipe
]

const modules = [
  // CKEditorModule,
  NgSelectModule,
]


@NgModule({

  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    TranslateModule.forChild({}),
    directives,
    pipes,
    modules
  ],
  exports: [
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    components,
    directives,
    pipes,
    modules
    // Components
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') === 'ar' ? 'ar-EG' : 'en-US' },
    DirtyCheckGuard,
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
  ],
  declarations: [
    components,
  ]
})
export class SharedModule { }
